export function buildSubscriptionPayload({ license, customerName, customerCpf }) {
  if (!license?.license_type) {
    throw new Error('Licença inválida');
  }

  const name = customerName?.trim() || '';
  if (!name) {
    throw new Error('Informe seu nome completo');
  }

  const cpf = customerCpf?.replace(/\D/g, '') || '';
  if (cpf.length !== 11) {
    throw new Error('Informe um CPF válido com 11 dígitos');
  }

  return {
    order: {
      license_code: license.license_code,
      license_type: license.license_type,
      licenseId: license.license_code,
      amount: license.price,
      currency: 'BRL',
      description: license.license_name ?? license.license_code,
    },
    customer: {
      name,
      cpf,
    },
    metadata: {
      billing_type: 'SUBSCRIPTION',
    },
  };
}
